export default {
  computed: {
    // 港股
    isHK() {
      return this.stock.market === 'HK'
    },
    // 美股
    isUS() {
      return this.stock.market === 'US'
    },
    // 美股正股
    isUSStock() {
      return this.isStock && this.stock.market === 'US'
    },
    // 英股
    isUK() {
      return this.stock.market === 'UK'
    },
    // 沪深
    isAStock() {
      return ['SH', 'SZ', 'CN'].includes(this.stock.market)
    },
    // 期货
    isFut() {
      return this.stock.market === 'FUT'
    },
    // 正股
    isStock() {
      return this.stock.secType === 'STK'
    },
    // 期权
    isOpt() {
      return this.stock && this.stock.secType === 'OPT'
    },
    // 窝轮牛熊证
    isWar() {
      return ['WAR', 'IOPT'].includes(this.stock.secType)
    },
    // 指数
    isIndex() {
      return this.stock.symbolType === 'index'
    },
    // 不是ETF
    isNotETFStock() {
      return !this.stock.etf || this.stock.etf === 0
    }
  }
}
